import RestService from "../services/rest.service";

export const getInboxDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/inbox/kpi/${serial}`).then(
      (response) => {
        let data = response.data.data
        dispatch({
          type: "SET_INBOX_DETAIL",
          payload: data
        });
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        dispatch({
          type: "SET_INBOX_DETAIL",
          payload: {}
        });
        reject()
      }
    );
  })
};

export const postWorkflowSubmit = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/goal/submit`, data).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowReject = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/goal/reject`, data).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowCancel = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/goal/cancel`, data).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postWorkflowRequest = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/goal/request`, data).then(
      (response) => {
        resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject();
      }
    );
  });
}